function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8461 23.6946C23.8461 17.777 19.049 12.9893 13.1407 12.9893C7.23243 12.9893 2.42615 17.777 2.42615 23.6946",
  stroke: "#9E9E9E",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4738 13.1089C11.4738 13.1089 11.0293 10.1455 13.1037 10.1455C15.1781 10.1455 14.6873 12.9793 14.6873 12.9793",
  stroke: "#9E9E9E",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 24H25.0036",
  stroke: "#9E9E9E",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99192 6.93608C8.99192 6.93608 9.56608 6.27858 9.56608 5.19508C9.56608 4.13936 8.53815 3.63003 8.53815 2.58357C8.53815 1.60194 9.37161 1 9.37161 1",
  stroke: "#9E9E9E",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0481 6.93608C13.0481 6.93608 13.6222 6.27858 13.6222 5.19508C13.6222 4.13936 12.5943 3.63003 12.5943 2.58357C12.5943 1.60194 13.4278 1 13.4278 1",
  stroke: "#9E9E9E",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1134 6.93608C17.1134 6.93608 17.6876 6.27858 17.6876 5.19508C17.6876 4.13936 16.6597 3.63003 16.6597 2.58357C16.6597 1.60194 17.4931 1 17.4931 1",
  stroke: "#9E9E9E",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgFoodPlate = function SvgFoodPlate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoodPlate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FoodPlate.c7617a88.svg";
export { ForwardRef as ReactComponent };